var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":80,"color":"primary","width":"3","indeterminate":""}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }